import { Component, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { DetailComponent } from '@app/common/templates/detail/detail.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { environment } from '@environments/environment';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

//<!-- CalendarModuleEx TESTING -->
	//<!-- ................................................ -->
	//<!-- ................................................ -->
	//<!-- ................................................ -->
	//<!-- ................................................ -->
	//<!-- ................................................ -->

//import {
//  ChangeDetectionStrategy,
//  ViewChild,
//  TemplateRef,
//} from '@angular/core';
//import {
//  startOfDay,
//  endOfDay,
//  subDays,
//  addDays,
//  endOfMonth,
//  isSameDay,
//  isSameMonth,
//  addHours,
//} from 'date-fns';
//import { Subject } from 'rxjs';
////import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//	import {
//	  CalendarEvent,
//	  CalendarEventAction,
//	  CalendarEventTimesChangedEvent,
//	  CalendarView,
//	} from 'angular-calendar';
//	import { EventColor } from 'calendar-utils';
//
//	const colors: Record<string, EventColor> = {
//	  red: {
//	    primary: '#ad2121',
//	    secondary: '#FAE3E3',
//	  },
//	  blue: {
//	    primary: '#1e90ff',
//	    secondary: '#D1E8FF',
//	  },
//	  yellow: {
//	    primary: '#e3bc08',
//	    secondary: '#FDF1BA',
//	  },
//	};

	//<!-- ................................................ -->
	//<!-- ................................................ -->
	//<!-- ................................................ -->
	//<!-- ................................................ -->
	//<!-- ................................................ -->
	//<!-- ENDE CalendarModuleEx TESTING -->

@Component({
	templateUrl: './detail.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/detail/style.scss'],
	providers: [MessageService, ConfirmationService]
})
export class TblAbfallartDetailComponent extends DetailComponent {
	//env_supportmail: string = '';

//<!-- CalendarModuleEx TESTING -->
//<!-- ................................................ -->
//<!-- ................................................ -->
//<!-- ................................................ -->
//<!-- ................................................ -->
//<!-- ................................................ -->
//@ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
//
//  view: CalendarView = CalendarView.Month;
//
//  CalendarView = CalendarView;
//
//  viewDate: Date = new Date();
//
//  modalData: {
//    action: string;
//    event: CalendarEvent;
//  };
//
//  actions: CalendarEventAction[] = [
//    {
//      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
//      a11yLabel: 'Edit',
//      onClick: ({ event }: { event: CalendarEvent }): void => {
//        this.handleEvent('Edited', event);
//      },
//    },
//    {
//      label: '<i class="fas fa-fw fa-trash-alt"></i>',
//      a11yLabel: 'Delete',
//      onClick: ({ event }: { event: CalendarEvent }): void => {
//        this.events = this.events.filter((iEvent) => iEvent !== event);
//        this.handleEvent('Deleted', event);
//      },
//    },
//  ];
//
//  refresh = new Subject<void>();
//
//  events: CalendarEvent[] = [
//    {
//      start: subDays(startOfDay(new Date()), 1),
//      end: addDays(new Date(), 1),
//      title: 'A 3 day event',
//      color: { ...colors.red },
//      actions: this.actions,
//      allDay: true,
//      resizable: {
//        beforeStart: true,
//        afterEnd: true,
//      },
//      draggable: true,
//    },
//    {
//      start: startOfDay(new Date()),
//      title: 'An event with no end date',
//      color: { ...colors.yellow },
//      actions: this.actions,
//    },
//    {
//      start: subDays(endOfMonth(new Date()), 3),
//      end: addDays(endOfMonth(new Date()), 3),
//      title: 'A long event that spans 2 months',
//      color: { ...colors.blue },
//      allDay: true,
//    },
//    {
//      start: addHours(startOfDay(new Date()), 2),
//      end: addHours(new Date(), 2),
//      title: 'A draggable and resizable event',
//      color: { ...colors.yellow },
//      actions: this.actions,
//      resizable: {
//        beforeStart: true,
//        afterEnd: true,
//      },
//      draggable: true,
//    },
//  ];
//
//  activeDayIsOpen: boolean = true;
//<!-- ................................................ -->
//<!-- ................................................ -->
//<!-- ................................................ -->
//<!-- ................................................ -->
//<!-- ................................................ -->
//<!-- ENDE CalendarModuleEx TESTING -->

	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public messageService: MessageService,
		public router: Router,
		public translate: TranslateService,
		@Optional() public config?: DynamicDialogConfig,
		@Optional() public ref?: DynamicDialogRef,
	) {
		super(accountService, breadcrumbService, confirmationService, crudService, messageService, router, translate, config, ref);

		this.env_supportmail = environment.supportEmail;
		if(!this.env_supportmail || this.env_supportmail.trim().length < 1) {
			this.env_supportmail = 'support@visy-gmbh.com';
		}
		this.apiUrl = 'TblAbfallart';
		this.name = 'MENU.ABFALLART';
		this.url = '/' + PATH.ABFALLART;
		this.fieldgroups.push(
			[
				{ type: 'text', key: 'ankey', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 400 },
			],
			[
				{ type: 'object', key: 'FREMD_typ_bezeichnung', required: false, width: 400, url: '/abfallart_typ', id: 'typ_id' },
				{ type: 'object', key: 'FREMD_avvE_bezeichnung', required: false, width: 400, url: '/avv', id: 'avvE_id' },
				{ type: 'object', key: 'FREMD_avvA_bezeichnung', required: false, width: 400, url: '/avv', id: 'avvA_id' },
				{ type: 'object', key: 'FREMD_avv_bezeichnung', required: false, width: 400, url: '/avv', id: 'avv_id' },
				{ type: 'text', key: 'barcode', required: false, width: 400 },
				{ type: 'text', key: 'barcode_text', required: false, width: 400 },
				{ type: 'numeric', key: 'barcode_ziffer', required: false, width: 400 },
				{ type: 'numeric', key: 'check_barcode_ziffer_index', required: false, width: 400 },
				{ type: 'numeric', key: 'schuettungsstopp_modus', required: false, width: 400 },
			]
		);
		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.DETAIL', routerLink: [this.url + '/' + PATH.DETAIL + '/' + this.id] }
		]);

    // Beispiel: Füge drei Termine ein
    //this.crudService.addEventEx('Ich bin ein Test-Termin', 2025, 6, 1, 2025, 6, 1, 14, 41, 15, 0, 1).then(resOne => {
    //  console.log(resOne);
    //  this.crudService.addEventEx('Urlaub', 2025, 6, 15, 2025, 6, 15).then(resTwo => {
    //    console.log(resTwo);
    //    this.crudService.addEventEx('Feiertag', 2025, 6, 19, 2025, 6, 19, 14, 0).then(resThree => {
    //      console.log(resThree);
//
    //      ///////////////
    //      this.crudService.getEventsByMonth(2025, 6).then(res => {
    //        console.log(res);
    //      }).catch(err => {
    //        console.log(err);
    //      });
    //      //////////////
    //      
    //    }).catch(errThree => {
    //      console.log(errThree);
    //    })
    //  }).catch(errTwo => {
    //    console.log(errTwo);
    //  });
    //}).catch(errOne => {
    //  console.log(errOne);
    //});

    ///////////////
    // Bsp.: Lade alle Termine des Juni 2025
    //this.crudService.getEventsByMonth(2025, 6).then(res => {
    //  console.log(res);
    //}).catch(err => {
    //  console.log(err);
    //});
    //////////////
	}

	//<!-- CalendarModuleEx TESTING -->
	//<!-- ................................................ -->
	//<!-- ................................................ -->
	//<!-- ................................................ -->
	//<!-- ................................................ -->
	//<!-- ................................................ -->

	//dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
  //  if (isSameMonth(date, this.viewDate)) {
  //    if (
  //      (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
  //      events.length === 0
  //    ) {
  //      this.activeDayIsOpen = false;
  //    } else {
  //      this.activeDayIsOpen = true;
  //    }
  //    this.viewDate = date;
  //  }
  //}
//
  //eventTimesChanged({
  //  event,
  //  newStart,
  //  newEnd,
  //}: CalendarEventTimesChangedEvent): void {
  //  this.events = this.events.map((iEvent) => {
  //    if (iEvent === event) {
  //      return {
  //        ...event,
  //        start: newStart,
  //        end: newEnd,
  //      };
  //    }
  //    return iEvent;
  //  });
  //  this.handleEvent('Dropped or resized', event);
  //}
//
  //handleEvent(action: string, event: CalendarEvent): void {
  //  this.modalData = { event, action };
  //  //this.modal.open(this.modalContent, { size: 'lg' });
	//alert('this.modal TROUBLE UNRESOLVED');
  //}
//
  //addEvent(): void {
  //  this.events = [
  //    ...this.events,
  //    {
  //      title: 'New event',
  //      start: startOfDay(new Date()),
  //      end: endOfDay(new Date()),
  //      color: colors.red,
  //      draggable: true,
  //      resizable: {
  //        beforeStart: true,
  //        afterEnd: true,
  //      },
  //    },
  //  ];
  //}
//
  //deleteEvent(eventToDelete: CalendarEvent) {
  //  this.events = this.events.filter((event) => event !== eventToDelete);
  //}
//
  //setView(view: CalendarView) {
  //  this.view = view;
  //}
//
  //closeOpenMonthViewDay() {
  //  this.activeDayIsOpen = false;
  //}
//
	//<!-- ................................................ -->
	//<!-- ................................................ -->
	//<!-- ................................................ -->
	//<!-- ................................................ -->
	//<!-- ................................................ -->
	//<!-- ENDE CalendarModuleEx TESTING -->

	setzeAktiv() {
		this.confirmationService.confirm({
			message: this.translate.instant('CONFIRMATION.ACTIVATE_QUESTION'),
			header: this.translate.instant('CONFIRMATION.CONFIRM'),
			icon: 'pi pi-exclamation-triangle',
			acceptLabel: this.translate.instant('CONFIRMATION.YES'),
			rejectLabel: this.translate.instant('CONFIRMATION.NO'),
			accept: () => {
				this.internal_AktivInaktiv(true);
			}
		});
	}

	setzeInaktiv() {
		this.confirmationService.confirm({
			message: this.translate.instant('CONFIRMATION.DEACTIVATE_QUESTION'),
			header: this.translate.instant('CONFIRMATION.CONFIRM'),
			icon: 'pi pi-exclamation-triangle',
			acceptLabel: this.translate.instant('CONFIRMATION.YES'),
			rejectLabel: this.translate.instant('CONFIRMATION.NO'),
			accept: () => {
				this.internal_AktivInaktiv(false);
			}
		});
	}

	private async internal_AktivInaktiv(value: boolean) {
		this.loading += 1;
		this.crudService.setFractionActiveState(this.entry.ds_this_id, value).then(() => {
			window.location.reload();
		}).catch(err => {
			err.error.forEach(e => {
				if (this.translate.instant('ERRORCODE.' + e.Code) === 'ERRORCODE.' + e.Code) {
					this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.UNKNOWN', { code: e.Code }), detail: e.Code + ": " + e.Description, life: 30000 });
				} else {
					this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.' + e.Code), detail: this.translate.instant('ERRORMSG.' + e.Code), life: 30000 });
				}
			})
		}).finally(() => {
			this.loading -= 1;
		});
	}
}
